// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Identifiers_mainWrapper__6KNjv","boxWrapper":"Identifiers_boxWrapper__XrOPK","rowWrapper":"Identifiers_rowWrapper__mzQIH"};